export default {
  confirmLabel: 'Ок',
  backspaceLabel: 'возврат на одну позицию',
  cancelKeyboardLabel: 'Отменить клавиатуру'
}



// WEBPACK FOOTER //
// ./src/components/input-item/locale/ru_RU.js